import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Alert } from 'react-bootstrap';
import LicService from '../../../../../services/licitacao-auth';
import { Link, useParams } from 'react-router-dom';



const FormSituacao = () => {
    const [objeto, setObjeto] = useState("");
    const [sit, setSit] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([]);
    const { id } = useParams();

    async function fetchLic(id) {
        const response = await LicService.licEdit(id);
        setObjeto(response.data["objeto"]);
        defineSituacao(response.data["situacao"])
    }

    const defineSituacao = (situacao) => {
        switch (situacao) {
            case "Em Andamento":
                setSit("andamento")
                break;
            case "Publicada":
                setSit("avisos")
                break;
            case "Homologada":
            case "Cancelada":
                setSit("encerradas")
                break;
            default:
                setSit("todas")
                break;
        }
    }

    useEffect(() => {
        fetchLic(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const lic = await LicService.editar(id, {
                objeto: objeto
            })
            if (lic.data["cod_lic"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado na edição!")
            }
        } catch (error) {
            setError(error)
        }
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <div className="da-espaco">
                        <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                            <Row xs={1} lg={3}>
                                <Col xs={12} lg={12}>
                                    <Form.Group className="mb-3" controlId="Objeto">
                                        <FloatingLabel
                                            label="Objeto"
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                required
                                                type="textarea"
                                                name="objeto"
                                                value={objeto}
                                                onChange={e => setObjeto(e.target.value)} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={2}>
                                    <Button type='submit' variant='primary'>Salvar</Button>
                                </Col>
                            </Row>

                        </Form>
                        <br />
                        <Link to={`/restrito/licitacao/listar/${sit}`}>
                            <Button variant="danger" type="button">
                                Cancelar
                            </Button>
                        </Link>
                    </div>
                </Container>
            </Fragment>
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Licitação editada com sucesso!</Alert>
                <Link to={`/restrito/licitacao/listar/${sit}`}>
                    <Button variant="primary" type="button">
                        Ir para Listagens de Licitações {sit}
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default FormSituacao